// extracted by mini-css-extract-plugin
export default {"indicators":"HeroIndicators_indicators__gG9oM","indicator":"HeroIndicators_indicator__uuKBT","active":"HeroIndicators_active__Cvfk4"};